import { createClient } from '@/shared/api';
import type { EditFindingsMutation, EditFindingsMutationVariables } from '@/shared/api';
import EDIT_FINDINGS from '../mutations/editFindings';

/**
 * Saves the edited findings section of a report, optionally with the physician's signature. Runs the editFindings mutation and throws the returned message when it does not report success.
 *
 * @param id - Identifier of the report to update.
 * @param reportFindings - Findings text to store.
 * @param signature - Optional physician signature to attach.
 * @returns A promise resolving once the findings have been saved.
 */
const handleEditFindings = async (id: any, reportFindings: any, signature?: any) => {
  const client = createClient();
  const result = await client.mutate<EditFindingsMutation, EditFindingsMutationVariables>({
    mutation: EDIT_FINDINGS,
    variables: {
      id,
      reportFindings,
      signature,
    },
  });
  const { data } = result;
  // API always returns this field for a resolved mutation; code already accessed it unconditionally.
  const { editFindings } = data!;
  if (!editFindings.isSuccess) {
    throw new Error(editFindings.message ?? undefined);
  }
};

export default handleEditFindings;
